import React from "react";
import Styles from './styles.module.scss'

import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";
import ForgotMain from "../../components/forgotMain";



const ForgotPage = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Восстановление пароля')}/>
            <ForgotMain/>
        </section>
    );
};

export default ForgotPage;